import { useCallback } from 'react'
import { EligibleProductStatus, ProductBundle } from '@typesApp/Product'
import { eligibleProductController } from '@hooks/eligible-product-check/eligibleProductCheckController'
import { useCart } from '@hooks/useCart'
import { useClaimRecord } from '@hooks/useClaimRecord'
import { useFetchClaimRecord } from '@hooks/useFetchClaimRecord'
import { useCheckEligibleProductsMutation } from '@redux/queries/claimRecords'

type UseEligibleProductStatusReturn = {
  fetchEligibleProductStatus: () => Promise<EligibleProductStatus | undefined>
}

export const useEligibleProductStatus = (): UseEligibleProductStatusReturn => {
  const { fetchCartBundle } = useCart()
  const { claimRecordId } = useClaimRecord()
  const { fetchClaimRecord } = useFetchClaimRecord()
  const [triggerCheck] = useCheckEligibleProductsMutation()

  const fetchEligibleProductStatus = useCallback(async (): Promise<EligibleProductStatus | undefined> => {
    const service = {
      fetchClaimRecord,
      fetchCartBundle,
      fetchEligibleProducts: (products: ProductBundle[]) => triggerCheck(products).unwrap(),
    }

    const controller = eligibleProductController(service, claimRecordId)
    return await controller.checkEligibility()
  }, [triggerCheck, fetchClaimRecord, fetchCartBundle, claimRecordId])

  return {
    fetchEligibleProductStatus,
  }
}
